import { lazy } from 'react';

export const BusinessProfileLazy = lazy(() => import('./business-profile'));
